module.exports = __webpack_public_path__ + "static/media/skywallet_6.6c5560fa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/skywallet_6.jpeg
// module id = 1507
// module chunks = 0